import { CONFIG, api } from './_barrel.js';


        // Report generation runs OFF the request path: POST queues the report,
        // we poll its status, then download the stored PDF when it's ready. This
        // replaces the old "POST returns the PDF stream" flow, which blocked and
        // could time out on large reports. Optional onStatus(msg) drives UI text.
        async function enqueueAndDownloadReport(token, subjectId, { onStatus } = {}) {
            const H = { 'Authorization': `Bearer ${token}` };
            const enq = await fetch(`${CONFIG.apiBase}/api/v1/subjects/${subjectId}/report`, {
                method: 'POST', headers: H,
            });
            if (!enq.ok) throw new Error((await enq.text()) || `Queue failed: ${enq.status}`);
            const { report_id } = await enq.json();
            if (!report_id) throw new Error('No report id returned.');

            onStatus && onStatus('Rendering report…');
            const started = Date.now();
            let st = null;
            while (Date.now() - started < 5 * 60 * 1000) {   // 5-minute ceiling
                await new Promise(r => setTimeout(r, 2500));
                let sr;
                try {
                    sr = await fetch(`${CONFIG.apiBase}/api/v1/subjects/${subjectId}/report/${report_id}/status`, { headers: H });
                } catch (e) { continue; }                    // transient network; keep polling
                if (!sr.ok) continue;
                st = await sr.json();
                if (st.status === 'generated') break;
                if (st.status === 'failed') throw new Error(st.error || 'Report generation failed.');
            }
            if (!st || st.status !== 'generated') throw new Error('Timed out waiting for the report to render.');

            onStatus && onStatus('Downloading…');
            const dl = await fetch(`${CONFIG.apiBase}/api/v1/reports/${report_id}/download`, { headers: H });
            if (!dl.ok) throw new Error(`Download failed: ${dl.status}`);
            const blob = await dl.blob();
            const cd = dl.headers.get('Content-Disposition') || '';
            const m = cd.match(/filename="([^"]+)"/);
            const filename = m ? m[1] : `${st.report_number || report_id}.pdf`;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url; a.download = filename;
            document.body.appendChild(a); a.click(); a.remove();
            window.URL.revokeObjectURL(url);
            return { report_id, report_number: st.report_number };
        }

export { enqueueAndDownloadReport };
